import React, {useState, useContext, useRef} from 'react';
import { IonContent, IonText, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonDatetime, IonFooter, IonImg } from '@ionic/react';
import { IonSlides, IonSlide, IonLabel } from '@ionic/react';

import { EnterPasswordModal } from '../../../zInternal_Features/merchant/components/Modal_EnterPassword';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { TakePhoto, photos } from '../../../zInternal_Features/merchant/components/TakePhoto';

import '../../../css/layout.css';

import { Preferences } from '@capacitor/preferences'

import { useHistory} from "react-router-dom";

function setFunction_initialSetup(event) {

    Preferences.set({
        key: 'initial_setup',
        //value: event,
        value: JSON.stringify({
            setup_id: event[0],
            details: event[1],
            status: event[2],
            dateCreated: event[3],
            lastModified: event[4],
        })

    })

}

function setFunction_tutorial(event) {


    alert("in SET FUNCTION TUTORIAL");
    alert(event);

    Preferences.set({
        key: 'selected_tutorial',
        //value: event,
        value: JSON.stringify({
            tutorial_id: event[0],
            tutorial_name: event[1],
            details: event[2],
            status: event[3],
            dateCreated: event[4],
            lastModified: event[5],
        })

    })

}

export function CreateInventoryRoomModal (props) {

    //alert('inside CreateEmployeeModal');
    //alert(props.openModal);

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [selectedFile, setSelectedFile] = useState(null);

    let [roomID, setRoomID] = useState(null);
    let [roomDateCreated, setRoomDateCreated] = useState(null);
    let [roomImageNumber, setRoomImageNumber] = useState(null);
    let [roomPic1, setRoomPic1] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpeg");
    let [roomPic2, setRoomPic2] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpeg");
    let [roomPic3, setRoomPic3] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpeg");
    let [roomPic4, setRoomPic4] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpeg");
    let [roomPicsModal, setRoomPicsModal] = useState(false);

    let [takePhotoStatus1, setTakePhotoStatus1] = useState(false);
    let [takePhotoStatus2, setTakePhotoStatus2] = useState(false);
    let [takePhotoStatus3, setTakePhotoStatus3] = useState(false);
    let [takePhotoStatus4, setTakePhotoStatus4] = useState(false);

    let [showPasswordModal, setShowPasswordModal] = useState(false);
    let [createRoomPublicPrice, setCreateRoomPublicPrice] = useState(null);

    let createRoomTypeRef = useRef();
    let createRoomDescriptionRef = useRef();
    let createRoomPartNumRef = useRef();
    let createRoomPhoneNumberRef = useRef();
    let createRoomAddressRef = useRef();
    let createRoomCityRef = useRef();
    let createRoomCountryRef = useRef();
    let createRoomCostPerUnitRef = useRef();
    //let createRoomSalePriceRef = useRef();
    let [createRoomSalePrice, setCreateRoomSalePrice] = useState('');

    //let selectedFileRef = useRef();

    let history = useHistory();

    function handleRoute(event)
    {
        //alert(authenticatedMerchent_context.authenticated);

        //history.push(event);
        window.location.pathname = event;

    }

    function createRoom(e)
    {
                e.preventDefault();

        //let totalRoomPics = [roomPic1, roomPic2, roomPic3, roomPic3];
       // alert("In Crate Room Function");
       // alert(pic1.value);
       // alert(pic2.value);
       // alert(pic3.value);
       // alert(pic4.value);
       //alert(totalRoomPics);

        
        let formData = new FormData();
        //formData.append('xRoomPics', totalRoomPics);
        //formData.append('xRoomPics', [roomPic1, roomPic2, roomPic3, roomPic3]);
        formData.append('Tracker', 74300);
        formData.append('user', acctID);
        formData.append('merchantSchema', schema);
        formData.append('xInventoryRoomType', createRoomTypeRef.current.value);
        formData.append('xInventoryRoomDescription', createRoomDescriptionRef.current.value);
        formData.append('xInventoryRoomPartNum', createRoomPartNumRef.current.value);
        formData.append('xInventoryRoomPhoneNumber', createRoomPhoneNumberRef.current.value);
        formData.append('xInventoryRoomAddress', createRoomAddressRef.current.value);
        formData.append('xInventoryRoomCity', createRoomCityRef.current.value);
        formData.append('xInventoryRoomCountry', createRoomCountryRef.current.value);
        formData.append('xInventoryRoomCostPerUnit', createRoomCostPerUnitRef.current.value);
        formData.append('xInventoryRoomSalePrice', createRoomSalePrice);
        formData.append('xInventoryRoomPublicPrice', createRoomPublicPrice);
        formData.append('xSupportingDocumentation', selectedFile);
        //formData.append('xEnterAdminPassword', adminPassword);
        formData.append('xPic1', roomPic1);
        formData.append('xPic2', roomPic2);
        formData.append('xPic3', roomPic3);
        formData.append('xPic4', roomPic4);
        formData.append('sessionID', sessionID);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        

        
        /*const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74300',
                user: acctID,
                xPic1: roomPic1,
                xPic2: roomPic2,
                xPic3: roomPic3,
                xPic4: roomPic4,
                xInventoryRoomType: createRoomTypeRef.current.value,
                xInventoryRoomDescription: createRoomDescriptionRef.current.value,
                xInventoryRoomPartNum: createRoomPartNumRef.current.value,
                xInventoryRoomPhoneNumber: createRoomPhoneNumberRef.current.value,
                xInventoryRoomAddress: createRoomAddressRef.current.value,
                xInventoryRoomCity: createRoomCityRef.current.value,
                xInventoryRoomCountry: createRoomCountryRef.current.value,
                xInventoryRoomCostPerUnit: createRoomCostPerUnitRef.current.value,
                xInventoryRoomSalePrice:  createRoomSalePriceRef.current.value,
                xSupportingDocumentation: selectedFile,
                //xEnterAdminPassword: adminPassword,
                sessionID: sessionID,
            })
        }*/

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
            let rows = data.toString().split('~~~');
            let cols = rows[0].split('|');

            //alert(authenticatedMerchent_context.initialSetup?.details?.step_3);
            //alert('PRODUCT_CREATED');
    
            if(authenticatedMerchent_context.initialSetup?.details?.step_3 == false && cols[1].trim() === 'ROOM_CREATED')
            {
                //alert("INITIAL SETUP PRODUCT CREATED");
                updateInitialSetup({step_1: true, step_2: true, step_3: true});
                activateMerchant_initial();
                //window.location.href = '/retail_merchantMainPageApp';
            }
            else if(
                ((authenticatedMerchent_context.selectedTutorial?.tutorial_id == '2' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false) ||
                (authenticatedMerchent_context.selectedTutorial?.tutorial_id == '3' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false)) && cols[1].trim() === 'ROOM_CREATED')
            {
                alert("TUTORIAL ROOM CREATED");
                updateSelectedTutorial({step_1: true, step_2: true});
                window.location.href = '/hotel_merchantMainPageApp';
            }
            else
            {
                alert("ROOM CREATED");
                window.location.href = '/hotel_merchantMainPageApp';
            }

        })
        .catch(error => {
            console.error(error);
        })

        props.closeModal(false)
    }


    function updateInitialSetup(event) {

        //alert("in updateInitialSetup");
        //alert(event);
 
 
         let formData = new FormData();
         formData.append('Tracker', '74003B_update_initialSetup');
         formData.append('user', acctID);
         formData.append('xInitialSetup_id', authenticatedMerchent_context.initialSetup.setup_id);
         formData.append('xInitialSetup_details', JSON.stringify(event));
         formData.append('sessionID', sessionID);
 
 
         const requestOptions = {
             enctype: 'multipart/form-data',
             method: 'POST',
             credentials: 'include',
             headers: {
                 'Accept': 'text/html, application/json',
                 //'content-type': 'application/json',
              },
             file: formData,
             body: formData,
             contentType: false,
             processData: false,
             /*body: JSON.stringify({
                 Tracker: '72001B',
                 user: acctID,
             })*/
         }
 
         fetch(baseURL+"hotel_merchantAcct_argsjqApp",requestOptions)
         .then(res => res.text())
         .then(res => {
 

            let rows = res.toString().split('~~~');
            let lines3 = rows[0].split('|');
            
             setFunction_initialSetup([lines3[0], lines3[1], lines3[2], lines3[3], lines3[4]]);

             let initialSetupParsed = {};
                
             try {
             initialSetupParsed = JSON.stringify({
                 setup_id: lines3[0],
                 details: lines3[1],
                 status: lines3[2],
                 dateCreated: lines3[3],
                 lastModified: lines3[4],
             })
                 ? JSON.parse(JSON.stringify({
                     setup_id: lines3[0],
                     details: lines3[1],
                     status: lines3[2],
                     dateCreated: lines3[3],
                     lastModified: lines3[4],
                 })) : {};

             if (typeof initialSetupParsed.details === 'string') {
                 initialSetupParsed.details = JSON.parse(initialSetupParsed.details);
             }
             } catch (e) {
             console.warn('Error parsing initialSetup:', e);
             initialSetupParsed = {};
             }


          authenticatedMerchent_context.changeInitialSetup(initialSetupParsed); 

             //alert("UPDATE COMPLETE");

             //history.push('/retail_merchantMainPageApp');
         })
     }

   function activateMerchant_initial() {

            // alert("in updateInitialSetup");
            // alert(event);
    
    
            let formData = new FormData();
            formData.append('Tracker', '00_activate_merchant_initial');
            formData.append('user', acctID);
            formData.append('sessionID', sessionID);
    
    
            const requestOptions = {
                enctype: 'multipart/form-data',
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    //'content-type': 'application/json',
                },
                file: formData,
                body: formData,
                contentType: false,
                processData: false,
                /*body: JSON.stringify({
                    Tracker: '72001B',
                    user: acctID,
                })*/
            }
    
            fetch(baseURL+'ghanaverified/', requestOptions)
            .then(res => res.text())
            .then(res => {
    

                let rows = res.toString().split('~~~');
                let lines = rows[0].split('|');
                
                
                alert(lines[1]);

                handleRoute('/hotel_merchantMainPageApp');
            })
        }


function updateSelectedTutorial(event) {

        alert("in updateSelectedTutorial");
        alert(event);
 
 
         let formData = new FormData();
         formData.append('Tracker', '11_update_selectedTutorial');
         formData.append('user', acctID);
         formData.append('xTutorial_id', authenticatedMerchent_context.selectedTutorial?.tutorial_id);
         formData.append('xTutorial_details', JSON.stringify(event));
         formData.append('sessionID', sessionID);
 
 
         const requestOptions = {
             enctype: 'multipart/form-data',
             method: 'POST',
             credentials: 'include',
             headers: {
                 'Accept': 'text/html, application/json',
                 //'content-type': 'application/json',
              },
             file: formData,
             body: formData,
             contentType: false,
             processData: false,
             /*body: JSON.stringify({
                 Tracker: '72001B',
                 user: acctID,
             })*/
         }
 
         fetch(baseURL+"retail_merchantAcct_argsjqApp",requestOptions)
         .then(res => res.text())
         .then(res => {
 

            alert("After UPDATING - Tutorial")
            alert(res);

            let rows = res.toString().split('~~~');

            let rowLength = rows.length;

            let cols = rows[0].split('|');


            setFunction_tutorial([event[0], event[1], cols[0], cols[1], event[4], event[5]]);

            let selectedTutorialParsed = {};

            try {
            selectedTutorialParsed = JSON.stringify({
                setup_id: event[0],
                name: event[1],
                details: cols[0],
                status: cols[1],
                dateCreated: event[4],
                lastModified: event[5],
            })
                ? JSON.parse(JSON.stringify({
                    setup_id: event[0],
                    namne: event[1],
                    details: cols[0],
                    status: cols[1],
                    dateCreated: event[4],
                    lastModified: event[5],
                })) : {};

            if (typeof selectedTutorialParsed.details === 'string') {
                selectedTutorialParsed.details = JSON.parse(selectedTutorialParsed.details);
            }
            } catch (e) {
            console.warn('Error parsing selectedTutorial:', e);
            selectedTutorialParsed = {};
            }


         authenticatedMerchent_context.changeSelectedTutorial(selectedTutorialParsed); 


             alert("UPDATE COMPLETE");

             history.push('/retail_merchantMainPageApp');
            //props.closeModal(false);
         })
     }
     

    function saveUploadedFile(event) {
    
        //alert(event);
        
        if(event.target.files === null)
        {
            //selectedFile = "/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg";
            setSelectedFile("/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg")

        }
        else
        {
            //selectedFileRef.current.value = event.target.files[0];
            setSelectedFile(event.target.files[0]);
        }


    }

    function saveRoomPictures(event) { 

        setRoomPic1(event.target.files[0]);
        setRoomPic2(event.target.files[1]);
        setRoomPic3(event.target.files[2]);
        setRoomPic4(event.target.files[3]);
    
    
    }

    function handleEnterAttachement() {  

        fetch(baseURL+'fileServer/merchants/image-not-available.jpeg')
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setRoomPic1(noImageFile);
            setRoomPic2(noImageFile);
            setRoomPic3(noImageFile);
            setRoomPic4(noImageFile);

            alert("No Room Pics Option checked");

        })
    }

        function selectedFileHandler1(event)
    {

        alert("in Photo");
        alert(event);

        setRoomImageNumber("1");
        setRoomPic1(event);
        setTakePhotoStatus1(false);
    }

    function selectedFileHandler2(event)
    {
        setRoomImageNumber("2");
        setRoomPic2(event);
        setTakePhotoStatus2(false);
    }
    function selectedFileHandler3(event)
    {
        setRoomImageNumber("3");
        setRoomPic3(event);
        setTakePhotoStatus3(false);
    }
    function selectedFileHandler4(event)
    {
        setRoomImageNumber("4");
        setRoomPic4(event);
        setTakePhotoStatus4(false);
    }

    function handleFileChange(event) {

        //alert("in HadndleFileChange");
        //alert(event.target.dataset.id);
        // alert(event.target);
        // alert(event.target.files);
        // alert(event.target.files[0]);

        if(event.target.dataset.id == "1")
        {
            const file = event.target.files ? event.target.files[0] : null;
            setRoomImageNumber(event.target.dataset.id);
            setRoomPic1(file);
        }
        if(event.target.dataset.id == "2")
        {
            const file = event.target.files ? event.target.files[0] : null;
            setRoomImageNumber(event.target.dataset.id);
            setRoomPic2(file);
        }
        if(event.target.dataset.id == "3")
        {
            const file = event.target.files ? event.target.files[0] : null;
            setRoomImageNumber(event.target.dataset.id);
            setRoomPic3(file);
        }
        if(event.target.dataset.id == "4")
        {
            const file = event.target.files ? event.target.files[0] : null;
            setRoomImageNumber(event.target.dataset.id);
            setRoomPic4(file);
        }
    }
    function handleCreateRoomSalePrice(event) {
        const salePrice = parseFloat(event) || 0; // convert to number, default 0
        setCreateRoomSalePrice(salePrice);
    
        const productPublicPrice = salePrice + (salePrice * 0.03);
        setCreateRoomPublicPrice(productPublicPrice);
    }

    function onSubmitPasswordHandler(enteredPassword)
    {
        alert('In onSubmitPasswordHandler');

        //setEnteredPassword(event);
        createRoom(enteredPassword);
    }

    function closeModalHandler() {

        props.closeModal(false);
    }
    
    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
        <form onSubmit={createRoom}>
        <IonHeader style={{color: "black"}}>
            <IonGrid>
                <IonRow>
                    <IonCol size='12'>
                        <IonText className='professional-text'>CREATE ROOM</IonText>
                    </IonCol>
                </IonRow>
            </IonGrid>
        </IonHeader>
        <IonContent className='grid_content'>
            <IonGrid>
                <IonRow>
                    <IonCol>
                        <IonLabel for="roomType">Room Type </IonLabel>
                        <select name="roomType" id='roomType' ref={createRoomTypeRef}>
                            <option value='std'>Standard</option>
                            <option value='dlx'>Deluxe</option>
                            <option value='exec'>Executive</option>
                        </select>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <IonLabel>Room Description: </IonLabel>
                        <IonInput placeholder='Enter Room Description' ref={createRoomDescriptionRef}></IonInput>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <IonLabel>Room Part Number: </IonLabel>
                        <IonInput placeholder='Enter Room Description' ref={createRoomPartNumRef}></IonInput>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <IonLabel>Room Phone Number: </IonLabel>
                        <IonInput placeholder='Enter Room Phone Number' ref={createRoomPhoneNumberRef }></IonInput>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <IonLabel>Room Address: </IonLabel>
                        <IonInput placeholder='Enter Room Address' ref={createRoomAddressRef}></IonInput>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <IonLabel>Room City: </IonLabel>
                        <IonInput placeholder='Enter Room City' ref={createRoomCityRef}></IonInput>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <IonLabel>Room Country: </IonLabel>
                        <IonInput placeholder='Enter Room Country' ref={createRoomCountryRef}></IonInput>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <IonLabel>Room Cost Per Unit: </IonLabel>
                        <IonInput placeholder='Enter Room Cost Per Unit' ref={createRoomCostPerUnitRef}></IonInput>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='12'>
                        <IonLabel className="form-label" position="stacked" >Merchant Price:</IonLabel>
                        <IonInput className='professional-input'
                        value={createRoomSalePrice}
                        type='number' 
                        step='any'
                        placeholder="Enter Room Sale Price"
                        onIonChange={(e) => handleCreateRoomSalePrice(e.target.value)}
                        required
                        ></IonInput>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='12'>
                        <IonLabel className="form-label" position="stacked" >Room Public Price:</IonLabel>
                        <IonText className='professional-text'>{createRoomPublicPrice}</IonText>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='12'>
                        <IonLabel className="form-label" position="stacked" >Image 1</IonLabel>
                        <IonImg src={roomPic1}></IonImg>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='5'>                            
                        <IonButton  onClick={() => setTakePhotoStatus1(true)}> Take Photo</IonButton>
                        {takePhotoStatus1 == true && <TakePhoto onSelectedFile={selectedFileHandler1}></TakePhoto>}
                    </IonCol>
                    <IonCol size='1'> 
                        <IonText>OR</IonText>
                    </IonCol>
                    <IonCol size='5'>
                        <input className='professional-input'
                            type="file"
                            accept="image/jpeg"
                            data-id='1'
                            onChange={handleFileChange}
                        />
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='12'>
                        <IonLabel className="form-label" position="stacked" >Image 2</IonLabel>
                        <IonImg src={roomPic2}></IonImg>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='5'>                            
                        <IonButton  onClick={() => setTakePhotoStatus2(true)}> Take Photo</IonButton>
                        {takePhotoStatus2 == true && <TakePhoto onSelectedFile={selectedFileHandler2}></TakePhoto>}
                    </IonCol>
                    <IonCol size='1'> 
                        <IonText>OR</IonText>
                    </IonCol>
                    <IonCol size='5'>
                        <input className='professional-input'
                            type="file"
                            accept="image/jpeg"
                            data-id='2'
                            onChange={handleFileChange}
                        />
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='12'>
                        <IonLabel className="form-label" position="stacked" >Image 3</IonLabel>
                        <IonImg src={roomPic3}></IonImg>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='5'>                            
                        <IonButton  onClick={() => setTakePhotoStatus3(true)}> Take Photo</IonButton>
                        {takePhotoStatus3 == true && <TakePhoto onSelectedFile={selectedFileHandler3}></TakePhoto>}
                    </IonCol>
                    <IonCol size='1'> 
                        <IonText>OR</IonText>
                    </IonCol>
                    <IonCol size='5'>
                        <input className='professional-input'
                            type="file"
                            accept="image/jpeg"
                            data-id='3'
                            onChange={handleFileChange}
                        />
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='12'> 
                        <IonLabel className="form-label" position="stacked" >Image 4</IonLabel>
                        <IonImg src={roomPic4}></IonImg>
                    </IonCol>
                    <IonCol size='5'>
                        <IonButton  onClick={() => setTakePhotoStatus4(true)}> Take Photo</IonButton>
                        {takePhotoStatus4 == true && <TakePhoto onSelectedFile={selectedFileHandler4}></TakePhoto>}
                    </IonCol>
                    <IonCol size='1'> 
                        <IonText>OR</IonText>
                    </IonCol>
                    <IonCol size='5'>
                        <input className='professional-input'
                            type="file"
                            accept="image/jpeg"
                            data-id='4'
                            onChange={handleFileChange}
                        />
                    </IonCol>
                </IonRow>
                {/*<IonRow>
                    <IonCol>
                        <IonLabel>Attachement </IonLabel>
                        <form id='fileUpload' enctype='multipart/form-data'>
                            <input type='file' name='imageFile' accept="image/*" onChange={(e) => saveUploadedFile(e)}></input>
                            <label for='noAttachment'>No Attachment</label>
                                <input type='checkbox' id='noAttachment' value='noImage' onClick={(e) => saveUploadedFile(e)}></input>
                        </form>
                    </IonCol>
                </IonRow>*/}
                <IonRow>
                    <IonCol>
                        {authenticatedMerchent_context.initialSetup?.details?.step_2 == false && <IonButton type='submit' className='flash-tutorial'>Confirm Room Creation</IonButton>}
                        {authenticatedMerchent_context.initialSetup?.details?.step_2 == true && <IonButton type='submit'>Confirm Room Creation</IonButton>}
                    </IonCol>
                </IonRow>   
            </IonGrid>                      
            {/*<EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>*/}
        </IonContent>
        <IonFooter className='grid_footer'>
            <IonGrid>
                <IonRow>
                    <IonCol>
                        <IonButton onClick={() => closeModalHandler()}>Cancel </IonButton>
                    </IonCol>
                </IonRow>
            </IonGrid>
        </IonFooter>
        </form>
        </IonModal>
        ) : null}
        </React.Fragment>
        )
}